// import package
import axios from "axios";

// import lib
import config from "../lib/config";

// import constant
import { SET_CURRENT_USER } from "../constant";

export const login = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/login`,
      data,
    });
    console.log("respData:", respData);

    localStorage.setItem("admin_token", respData.data.token);

    return {
      loading: false,
      result: respData.data.result,
    };
  } catch (err) {
    //console.lo(err)
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getadminuserdata = async (payload) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getAdminData`,
      params: payload,
    });
    return {
      success: true,
      adminData: respData.data,
    };
  } catch (error) {
    console.log("errs", error);
    return {
      success: false,
      error: error,
    };
  }
};

export const gettokenlist = async (filterData) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/gettokenlist`,
      params: filterData,
    });
    return respData.data;
  } catch (err) {
    return {
      Success: false,
      error: err.response.data.errors,
    };
  }
};

export const gettokendata = async (id) => {
  try {
    let respData = await axios({
      method: "get",
      url:
        `${config.API}/admin/panel/gettokendata/` +
        id.tokenOwner +
        "/" +
        id.tokenID,
    });
    return respData.data;
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deleteStatus = async (payload) => {
  try {
    console.log("adminPayload", payload);
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/deleteStatus`,
      data: payload,
    });
    return respData.data;
  } catch (error) {
    return {
      loading: false,
      // microValue: error
    };
  }
};

export const getuserslist = async (data) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getuserlist`,
      params: { skip: data?.skip ?? 0, limit: data?.limit ?? 5 }
    });
    return respData.data;
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const addbulkusers = async (data) => {
  console.log('====================================');
  console.log(data);
  console.log('====================================');
  try {
    var resp = await axios({

      'method': 'post',
      'url': `${config.API}/admin/panel/getemailfromexcel`,
      'headers': {
        "content-type": "multipart/form-data"
      },
      'data': data
    })
    console.log("bulk users resp", resp.data)
    return resp.data;
  }
  catch (err) { console.log("err in bulk users", err) }
}

export const CreateAndCheckValid = async (data) => {
  console.log('=========CreateAndCheckValid==========');
  console.log(data);
  console.log('=CreateAndCheckValid=============================');
  try {
    var resp = await axios({

      'method': 'post',
      'url': `${config.API}/admin/panel/CreateAndCheckValid`,
      'headers': {
        "content-type": "multipart/form-data"
      },
      'data': data
    })
    console.log("bulk users resp", resp.data)
    return resp.data;
  }
  catch (err) { console.log("err in bulk users", err) }
}

export const gettokencount = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/gettokencount`,
    });
    return respData.data;
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getcatorylist = async (data) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcatorylist`,
      params: data
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const addcategory = async (data) => {
  try {
    let bodydatafor = new FormData();
    bodydatafor.append("name", data.name);
    bodydatafor.append("image", data.image);
    bodydatafor.append("BulkStatus", data.BulkStatus);
    bodydatafor.append("SubCategory", data.SubCategory);
    bodydatafor.append("Collection", data.Collection);

    console.log("payload for add category playload comming", data)

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addcategory`,
      data: bodydatafor,
    });

    console.log("axios add category response", respData)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};

export const getcategorydata = async (id, coll) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcategorydata/` + id + "/" + coll,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updatecategory = async (data) => {
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("Photofile", data.Photofile);
    bodyFormData.append("userId", data.userId);
    bodyFormData.append("BulkStatus", data.BulkStatus);
    bodyFormData.append("SubCategory", data.SubCategory);
    bodyFormData.append("Collection", data.Collection);
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updatecategory`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updateSettings = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateSettings`,
      data,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getsettdata = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getsettdata`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getnftlist = async (filterData) => {
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/getnfttag/` + filterData.id,
    });
    return {
      loading: false,
      userValue: respData.data.userValue
    }
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const addfaq = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addfaq`,
      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getfaqlist = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getfaqlist`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updatefaq = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updatefaq`,
      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getfaq = async (id) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getfaq/` + id,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deletfaq = async (id) => {
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletefaq/` + id,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updateAdminProfile = async (payload) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateAdmin/`,
      data: payload,
    });
    return {
      loading: false,
      microValue: respData,
    };
  } catch (error) {
    return {
      loading: false,
      microValue: error,
    };
  }
};

export const updateuserProfile = async (payload) => {
  try {
    var respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateuser`,
      data: payload,
    });
    return respData.data
  } catch (error) {
    return respData.data
  }
};

export const deladd = async (payload) => {
  try {
    var respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateuser`,
      data: payload,
    });
    return respData.data
  } catch (error) {
    return respData.data
  }
};

export const PromoteNFT = async (Payload) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/promote`,
      data: Payload,
    })
    return respData.data
  }
  catch (error) {
    console.log("Error on Promote token")
    return { Success: false, Message: "Error.! Try again Later" }
  }
}

export const getpromotiontokenlist = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getpromotiontokenlist`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getCMSlist = async (data) => {
  console.log("come here", data);
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getCMSlist1`,
      params: data ? data : ''
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getcms1 = async (id) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcms1/` + id,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updatecms1 = async (data, ismid) => {
  try {
    let respData = null
    if (ismid) {
      let bodyFormData = new FormData();
      bodyFormData.append("question", data.question);
      bodyFormData.append("Photofile", data.Photofile);
      bodyFormData.append("answer", data.answer);
      bodyFormData.append("Id", data.Id);
      bodyFormData.append("title", data.title);
      bodyFormData.append("name", data.name);
      respData = await axios({
        method: "post",
        url: `${config.API}/admin/panel/updatecms1`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: bodyFormData,
      });
    }
    else {
      respData = await axios({
        method: "post",
        url: `${config.API}/admin/panel/updatecms1`,
        data,
      });
    }

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getpurchasetokenlist = async (data, dispatch) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getpurchasetokenlist`,
      params: data,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getreportlist = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getreportlist`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const takereportaction = async (Payload) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/takereportaction`,
      data: Payload
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getSubscriberList = async () => {
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/getSubscriberList`,
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err
    }
  }
}

export const sendSubscriberMail = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/sendSubscribeMail`,
      data
    });

    return respData.data
  } catch (error) {
    return {
      loading: false,
      error: error
    }
  }
}

export const updateSubscriberStatus = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/subscriberStatus`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}
export const updateUserStatus = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/userStatus`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const updateUserAllow = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/updateUserAllow`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const changeMaySent = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/user/changemaysent`,
      "headers": {
        "Authorization": localStorage.getItem("token")
      },
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}


export const deleteUsers = async () => {
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/deleteUsers`

    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const AddNFTlist = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/AddNFTlist`,
      data,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};



















export const updateProfile = async (data) => {
  // //console.lo(data,"dataaaaaaaaaaaaaaaaaaaa")
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("email", data.email);
    bodyFormData.append("mobilenumber", data.mobilenumber);
    bodyFormData.append("photo", data.photo);
    bodyFormData.append("company", data.company);
    bodyFormData.append("designation", data.designation);
    bodyFormData.append("detail", data.detail);
    ////console.lo(bodyFormData,"fdsfdsfsdfsdfsdfsdfsdfdsfsdfdsfdsfsdfsdfsdfsdfsdfsdfsdfsdf8888888888888888888888");
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateProfile`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.admin_token,
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getbidderscount = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getbidderscount`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.countData,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getemailTemplate = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getemailTemplate/` + id,
      headers: {
        Authorization: localStorage.user_token,
      },
    });

    //console.lo(respData.data)
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getemailTemplateList = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getemailTemplateList`,
    });

    //console.lo(respData,"RESdATA")

    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const updateEmailTemplate = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateEmailTemplate`,
      data,
    });

    //console.lo(respData,"respData");
    return {
      loading: false,
      result: respData.data.message,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const adminaccept = async (data, dispatch) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/adminaccept/`,
      headers: {
        Authorization: localStorage.user_token,
      },
      data,
    });
    //console.lo(respData.data);
    return {
      loading: false,
      result: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const adminreject = async (data, dispatch) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/adminreject/`,
      headers: {
        Authorization: localStorage.user_token,
      },
      data,
    });
    return {
      loading: false,
      result: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updateuser = async (data) => {
  ////console.lo(data,"dataaaaaaaaaaaaaaaaaaaa")
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("email", data.email);
    bodyFormData.append("phonenumber", data.phonenumber);
    bodyFormData.append("address1", data.address1);
    bodyFormData.append("address2", data.address2);
    bodyFormData.append("pincode", data.pincode);
    bodyFormData.append("city", data.city);
    bodyFormData.append("country", data.country);
    bodyFormData.append("Photofile", data.Photofile);
    bodyFormData.append("userId", data.userId);
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateuser`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.admin_token,
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getcms = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcms/` + id,
      headers: {
        Authorization: localStorage.user_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getcmslist = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcmslist`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const addpair = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addpair`,
      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const gettoken = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/gettoken`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const addtoken = async (data) => {
  //console.lo("#########", data)
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("tokencount", data.tokencount);
    bodyFormData.append("price", data.price);
    bodyFormData.append("tokenroyality", data.tokenroyality);
    bodyFormData.append("tokendesc", data.tokendesc);
    bodyFormData.append("Photofile", data.Photofile);

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addtoken`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.admin_token,
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const addVerifieddata = async (data) => {
  //console.lo("#########", data)
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("Rariblelinkprofile", data.Rariblelinkprofile);
    bodyFormData.append("Ethereumwalletaddress", data.Ethereumwalletaddress);
    bodyFormData.append("creator", data.creator);
    bodyFormData.append("collector", data.collector);
    bodyFormData.append("Tellusaboutyourself", data.Tellusaboutyourself);
    bodyFormData.append("screenshotimage", data.screenshotimage);

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addVerfieddata`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.admin_token,
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const addcategorydet = async (data) => {
  //console.lo(data, "dataaaaaaaaaaaaaaaaaaaa")
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("categoryname", data.cname);
    bodyFormData.append("tokenname", data.tname);
    bodyFormData.append("Photofile", data.Photofile);
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addcategorydet`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.admin_token,
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getburntokenlist = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getburntokenlist`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
    //console.lo("ok")
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
    //console.lo("not ok")
  }
};

export const getpromotion = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getpromotion`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
    //console.lo("ok")
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
    //console.lo("not ok")
  }
};

export const setPromotions = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/setPromotions`,
      data: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
    //console.lo("ok")
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
    //console.lo("not ok")
  }
};

//Preethi getverfiedlist
export const GetVerifiedList = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getverifiedlist`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
    //console.lo("ok")
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
    //console.lo("not ok")
  }
};
//Pretthi userslist
// export const getuserslist = async () => {
//   console.log("yes");
//   try {
//     let respData = await axios({
//       method: "get",
//       url: `${config.API}/admin/panel/getuserslist`,
//     });
//     console.log("DFdsfsd" + JSON.stringify(respData));
//     return {
//       userValue: respData.data,
//     };
//   } catch (err) {
//     return {
//       loading: false,
//       error: err.response.data.errors,
//     };
//   }
// };

export const adduser = async (data) => {
  //console.lo(data, "dataaaaaaaaaaaaaaaaaaaa")
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("email", data.email);
    bodyFormData.append("phonenumber", data.phonenumber);
    bodyFormData.append("address1", data.address1);
    bodyFormData.append("address2", data.address2);
    bodyFormData.append("pincode", data.pincode);
    bodyFormData.append("city", data.city);
    bodyFormData.append("country", data.country);
    bodyFormData.append("Photofile", data.Photofile);
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/adduser`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.admin_token,
      },
      data: bodyFormData,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const updatepair = async (data) => {
  //console.lo(data, "data")
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updatepair`,

      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    //console.lo("err", err)
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updatecms = async (data) => {
  //console.lo(data, "data")
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updatecms`,

      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    //console.lo("err", err)
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getBalance = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getBalance/`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const updateWithdraw = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateWithdraw`,
      data,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getadmintransaction = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getadmintransaction/`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const get2faadmin = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/get2faadmin/`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getadminwithdraw = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getadminwithdraw/`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getuser = async (id, dispatch) => {
  ////console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getuser/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const getReportView = async (id) => {
  console.log("yessss", id);
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getReportView/` + id,
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const deleteuser = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deleteuser/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const deletepair = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletepair/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deletenft = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletenft/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deletecategory = async (id, dispatch) => {
  console.log("yes", id);
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/deletecategorys/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deletegetVerfied = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletegetVerfied/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const deleteToken = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deleteToken/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getCmsList = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getCmsList`,
    });

    //console.lo(respData, "RESdATA")

    return {
      loading: false,
      cmsData: respData.data.cmsData,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getCmsData = async (id) => {
  //console.lo('yes', id)
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getCmsData/` + id,
    });

    //console.lo(respData, "RESdATA")

    return {
      loading: false,
      cmsData: respData.data.cmsData,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const updateCmsData = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updateCmsData`,
      data,
    });

    //console.lo(respData, "respData");
    return {
      loading: false,
      result: respData.data.message,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getContactUs = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getContactUs`,
    });

    //console.lo(respData, "respData");
    return {
      loading: false,
      result: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getContactDetails = async (id) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getContactDetails/` + id,
    });

    //console.lo(respData, "respData");
    return {
      loading: false,
      result: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const updatecontact = async (data) => {
  //console.lo(data, "data")
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/updatecontact`,

      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    //console.lo("err", err)
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const adminReplay = async (data, id) => {
  //console.lo('yes', data)
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/adminReplay/` + id,
      data,
    });
    return {
      data: respData.data.message,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const deletesupportchat = async (id, data, dispatch) => {
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletesupportchat/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
      data: data,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getChats = async (id) => {
  //console.lo('yes', id)
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getChats/` + id,
    });
    return {
      getChats: respData.data.ticketDatas[0].reply,
      ticket_id: respData.data.ticketDatas[0]._id,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const deletesupport = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletesupport/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getSupportList = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getSupportList`,
    });
    //console.lo("supportData", respData)
    return {
      loading: false,
      supportDetails: respData.data.supportData,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deletecontact = async (id, dispatch) => {
  //console.lo('deletecontact', id);
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/deletecontact/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const deletToken = async (id, dispatch) => {
  ////console.lo('yes');
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/deletToken/` + id,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};



export const getcount = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcount`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getusermonthly = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getusermonthly`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getdepositmonthly = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getdepositmonthly`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getwithdrawmonthly = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getwithdrawmonthly`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getuserdata = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getuserdata`,
      headers: {
        Authorization: localStorage.admin_token,
      },
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getpairdata = async (id) => {
  //console.lo('yes', id)
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getpairdata/` + id,
    });

    //console.lo(respData, "RESdATA")

    return {
      loading: false,
      cmsData: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

//added
export const getBidslist = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getBidslist`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getpairlist = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getpairlist`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getcatory = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcatory`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const getuserlisttrans = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getuserlisttrans`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getcsvdata = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getcsvdata`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getuserdaily = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getuserdaily`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getdepositdaily = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getdepositdaily`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getwithdrawdaily = async (token, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getwithdrawdaily`,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getdepositlist = async (filterData, dispatch) => {
  //  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getdepositlist`,
      params: filterData,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getwithdrawlist = async (filterData, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getwithdrawlist`,
      params: filterData,
    });
    //console.lo()
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const stautuchange = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/stautuchange`,
      data,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getusercustom = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getusercustom`,
      data,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getdepositcustom = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getdepositcustom`,
      data,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getwithdrawcustom = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/getwithdrawcustom`,
      data,
    });
    return {
      loading: false,
      userValue: respData.data.userValue,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const gettokenList = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/gettokenLists`,
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getSBTtokenlist = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getSBTtokenlist`,
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const SoulGet = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/SoulGet`,
      params: data
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const SBTCollectionShowHide = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/SBTCollectionShowHide`,
      params: data
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const SBTSigleShowHide = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/SBTSigleShowHide`,
      params: data
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getCurrentUser = async (token, dispatch) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API.userService}/api/currentUser`,
      headers: {
        Authorization: token,
      },
    });
    dispatch(setCurrentUser(respData.data.result));
    return true;
  } catch (err) {
    return false;
  }
};

export const setCurrentUser = (decoded) => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded,
  };
};

export const forgotPassword = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/forgotPassword`,
      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const changePassword = async (data) => {
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/forgotPassword`,
      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const logout = (history) => {
  localStorage.removeItem("admin_token");
  history.push("/Login");
};

export const resetPassword = async (data) => {
  try {
    let respData = await axios({
      method: "put",
      url: `${config.API}/admin/panel/resetPassword`,
      headers: {
        Authorization: localStorage.admin_token,
      },
      data,
    });

    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const BurnField = async (data) => {
  // //console.lo(data,"dataaaaaaaaaaaaaaaaaaaa")
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/BurnField`,

      data: data,
    });
    return {
      loading: false,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const setactivateUserAction = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/setActivateUser`,
      data,
    });
    return {
      loading: false,
      data: respData.data,
    };
  } catch (error) {
    return {
      loading: false,
      error: error,
    };
  }
};

export const AddWhiteList = async (data) => {
  try {
    let bodydatafor = new FormData();
    bodydatafor.append("Address", data.Address);

    console.log("payload for add category playload comming", data)

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/AddWhiteList`,
      data: bodydatafor,
    });

    console.log("axios add category response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};

export const getWhiteListUser = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getWhiteListUser`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const AddSoulWhiteList = async (data) => {
  try {
    let bodydatafor = new FormData();
    bodydatafor.append("Address", data.Address);

    console.log("payload for add category playload comming", data)

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/AddSoulWhiteList`,
      data: bodydatafor,
    });

    console.log("axios add category response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};

export const getSoulWhiteListUserData = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getSoulWhiteListUser1`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const Addplans = async (data) => {
  try {
    // let bodydatafor = new FormData();
    // bodydatafor.append("Address", data.Address);
    console.log("payload for add category playload comming", data)

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/Addplans`,
      data: data,
    });

    console.log("axios add category response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};



export const AddProduct = async (data) => {
  try {
    let bodydatafor = new FormData();
    bodydatafor.append("File", data.file);
    bodydatafor.append("data", JSON.stringify(data));
    console.log("payload for add category playload comming", data)

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/AddProduct`,
      data: bodydatafor,
    });

    console.log("axios add category response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};

export const veiwPack = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/ViewPlanDetails`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const getPackEditdata = async (id) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/getPlanEdit`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const EditplansData = async (data) => {
  try {
    console.log("dtgyjgykjfyhuj", data, data.file != "", data.file);
    let bodydatafor = new FormData();
    if (data.file != "") {
      bodydatafor.append("File", data.file);
    }
    bodydatafor.append("data", JSON.stringify(data));

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/EditplansDataDetails`,
      data: bodydatafor,
    });

    console.log("axios add category response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};



export const ChartDBData = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/ChartDatas`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const PackBuyerssList = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/PackBuyerssList`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const PackTableList = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/PackTableList`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const PackBuyerCount = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/PackBuyerCount`,
    });
    console.log("oioioioioioi", respData);
    return respData

  } catch (err) {
    console.log("adasdasdas", err);
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const Notifcation = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/Notifcation`,
    });
    console.log("oioioioioioi", respData);
    return respData

  } catch (err) {
    console.log("adasdasdas", err);
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const AdminEditUserPlans = async (data) => {
  try {
    // let bodydatafor = new FormData();
    // bodydatafor.append("Address", data.Address);
    console.log("AdminEditUserPlans", data)
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/AdminEditUserPlans`,
      data: data,
    });
    console.log("axios add AdminEditUserPlans response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error AdminEditUserPlans", err)
  }
};


export const AddProductPlan = async (data) => {

  let bodydatafor = new FormData();
  bodydatafor.append("File", data.file);
  bodydatafor.append("data", JSON.stringify(data));

  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/addproductplan`,
      data: bodydatafor,
    });
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error AdminEditUserPlans", err)
  }
};



export const UpdateProduct = async (data) => {

  let bodydatafor = new FormData();
  bodydatafor.append("File", data.file);
  bodydatafor.append("data", JSON.stringify(data));

  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/UpdataProductDetails`,
      data: bodydatafor,
    });
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error AdminEditUserPlans", err)
  }
};



export const GetProductDatas = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/GetProductDatas`,
    });
    console.log("GetProductDatasGetProductDatas", respData);
    return respData

  } catch (err) {
    console.log("adasdasdas", err);
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};



export const RevenueAnnual = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/RevenueAnnual`,
    });
    console.log("RevenueAnnual", respData);
    return respData

  } catch (err) {
    console.log("adasdasdas", err);
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const CountForAdminPack = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/PackCountAdminCount`,
    });
    console.log("RevenueAnnual", respData);
    return respData

  } catch (err) {
    console.log("adasdasdas", err);
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};



export const PackBuyerssListTabel = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/PackBuyerssListTabel`,
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const planvalidate = async (payload) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/planvalidate`,
      data: payload
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};
export const ProductChecker = async (payload) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/ProductChecker`,
      params: payload
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const Productvalidate = async (payload) => {
  try {
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/Productvalidate`,
      data: payload
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const CanpaignRevenue = async (payload) => {
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/CanpaignRevenue`,
      params: payload
    });
    return respData.data
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const GetBulkCollection = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/GetBulkCollection`,
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};


export const CollectionShowHide = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/CollectionShowHide`,
      params: data
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const CollectionGetOwn = async (data, dispatch) => {
  //console.lo('yes')
  try {
    let respData = await axios({
      method: "get",
      url: `${config.API}/admin/panel/CollectionGetOwn`,
      params: data
    });
    return {
      loading: false,
      userValue: respData.data,
    };
  } catch (err) {
    return {
      loading: false,
      error: err.response.data.errors,
    };
  }
};

export const SigleCollectionShowHide = async (payload) => {
  try {
    console.log("adminPayload", payload);
    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/SigleCollectionShowHide`,
      data: payload,
    });
    return respData.data;
  } catch (error) {
    return {
      loading: false,
      // microValue: error
    };
  }
};

export const updateCollectionStatus = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/updateCollectionStatus`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const CollectionMaySent = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/user/CollectionMaySent`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}

export const HideCollection = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/HideCollection`,
      params: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}


export const updateCollectionStatusSingle = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/updateCollectionStatusSingle`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const CollectionSingleMaySent = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/user/CollectionSingleMaySent`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}

export const HideCollectionSingle = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/HideCollectionSingle`,
      params: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const SBTCollectionMaySent = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/SBTCollectionMaySent`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const updateSbtcollectionStatus = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/user/updateSbtcollectionStatus`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}

export const HideCollectionSBT = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/HideCollectionSBT`,
      params: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const SBTMaySent = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/SBTMaySent`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const updateSBTStatus = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/user/updateSBTStatus`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}

export const HideSTB = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/HideSTB`,
      params: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const NFTsMaySent = async (data) => {
  try {
    let respData = await axios({
      'method': 'post',
      'url': `${config.API}/admin/panel/NFTsMaySent`,
      data: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const NFTStatus = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/user/NFTStatus`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}

export const HideNFTs = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/HideNFTs`,
      params: data
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const HideShowShowStatus = async (data) => {
  console.log("token data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/HideShowShowStatus`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add token err', err)
  }
}

export const EditKeyTemplate = async (data, Option) => {
  try {
    let bodydatafor = new FormData();
    bodydatafor.append("NameField", data.NameField);
    bodydatafor.append("NameFieldStatus", data.NameFieldStatus);
    bodydatafor.append("DobField", data.DobField);
    bodydatafor.append("DobFieldStatus", data.DobFieldStatus);
    bodydatafor.append("Weight", data.Weight);
    bodydatafor.append("WeightStatus", data.WeightStatus);
    bodydatafor.append("Height", data.Height);
    bodydatafor.append("HeightStatus", data.HeightStatus);
    bodydatafor.append("VaccineField", data.VaccineField);
    bodydatafor.append("VaccineStatus", data.VaccineStatus);
    bodydatafor.append("Mail", data.Mail);
    bodydatafor.append("MailStatus", data.MailStatus);
    bodydatafor.append("Discription", data.Discription);
    bodydatafor.append("DiscriptionStatus", data.DiscriptionStatus);
    bodydatafor.append("GenderDropDown", data.GenderDropDown);
    bodydatafor.append("GenderStatus", data.GenderStatus);
    bodydatafor.append("BreadDropDown", data.BreadDropDown);
    bodydatafor.append("BreadStatus", data.BreadStatus);
    bodydatafor.append("Chip", data.Chip);
    bodydatafor.append("ChipStatus", data.ChipStatus);
    bodydatafor.append("ContactNum", data.ContactNum);
    bodydatafor.append("ContactNumStatus", data.ContactNumStatus);
    bodydatafor.append("FileField", data.FileField);
    bodydatafor.append("FileStatus", data.FileStatus);
    bodydatafor.append("FileDiscriptionField", data.FileDiscriptionField);
    bodydatafor.append("FileDiscriptionStatus", data.FileDiscriptionStatus);
    bodydatafor.append("CheckBox1", data.CheckBox1);
    bodydatafor.append("CheckBox1Status", data.CheckBox1Status);
    bodydatafor.append("CheckBox2", data.CheckBox2);
    bodydatafor.append("CheckBox2Status", data.CheckBox2Status);
    bodydatafor.append("TemplateDesignName", data.TemplateDesignName)
    bodydatafor.append("Option", Option)

    console.log("payload for add category playload comming", data)

    let respData = await axios({
      method: "post",
      url: `${config.API}/admin/panel/EditKeyTemplate`,
      data: bodydatafor,
    });

    console.log("axios add category response", respData.data)
    return respData.data;

  } catch (err) {
    // return {
    //   loading: false,
    //   error: err.response.data.errors,
    // };

    console.log("error happened", err)
  }
};

export const GetFaitEvenue = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/GetFaitEvenue`,
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const ClaimRequestFiat = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/ClaimRequestFiat`,
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}

export const ChangeRequestStatus = async (data) => {
  console.log("ChangeRequestStatus data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/ChangeRequestStatus`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add ChangeRequestStatus err', err)
  }
}
export const SaveCustomToken = async (data) => {
  console.log("ChangeRequestStatus data", data)
  try {
    var resp = await axios({
      "method": "POST",
      "url": `${config.API}/admin/panel/SaveCustomToken`,
      "data": data,
    })

    return resp.data
  }
  catch (err) {
    console.log('add ChangeRequestStatus err', err)
  }
}

export const GetCustomToken = async (data) => {
  console.log("dasdasdasdas");
  try {
    let respData = await axios({
      'method': 'get',
      'url': `${config.API}/admin/panel/GetCustomToken`,
    });
    return respData.data
  }
  catch (err) {
    return {
      loading: false,
      error: err.response.data.errors
    }
  }
}
